// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1004;
  }
  
  .modal-box {
    background: #fff;
    padding: 16px 20px;
    border-radius: 12px;
    max-width: 650px;
    width: 90%;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    font-family: Arial, sans-serif;
  }
  .modal-box p{
    margin-bottom: 5px;
  }
  .modal-box hr{
    margin: 0px;
  }


  
  .modal-title {
    margin-top: 0;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .ticket-section {
    margin-top: 10px;
  }
  .ticket-group{
    max-height: 300px;
    overflow-y:auto
  }
  
  .ticket-section h3 {
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 16px;
    color: #333;
    position: sticky;
  }
  
  .ticket-section ul {
    list-style: disc;
    padding-left: 20px;
    margin: 0;
  }
  
  .ticket-section li {
    margin-bottom: 6px;
    font-size: 14px;
  }
  
  .close-button {
    margin-top: 10px;
    background-color: #1d0f40;
    color: white;
    padding: 5px 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
  
  .close-button:hover {
    background-color: #271456;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ticket-csv-uploader/TicketReportModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,0CAA0C;IAC1C,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;;;;EAIA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1004;\n  }\n  \n  .modal-box {\n    background: #fff;\n    padding: 16px 20px;\n    border-radius: 12px;\n    max-width: 650px;\n    width: 90%;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n    font-family: Arial, sans-serif;\n  }\n  .modal-box p{\n    margin-bottom: 5px;\n  }\n  .modal-box hr{\n    margin: 0px;\n  }\n\n\n  \n  .modal-title {\n    margin-top: 0;\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 5px;\n  }\n  \n  .ticket-section {\n    margin-top: 10px;\n  }\n  .ticket-group{\n    max-height: 300px;\n    overflow-y:auto\n  }\n  \n  .ticket-section h3 {\n    font-weight: bold;\n    margin-bottom: 8px;\n    font-size: 16px;\n    color: #333;\n    position: sticky;\n  }\n  \n  .ticket-section ul {\n    list-style: disc;\n    padding-left: 20px;\n    margin: 0;\n  }\n  \n  .ticket-section li {\n    margin-bottom: 6px;\n    font-size: 14px;\n  }\n  \n  .close-button {\n    margin-top: 10px;\n    background-color: #1d0f40;\n    color: white;\n    padding: 5px 16px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n  }\n  \n  .close-button:hover {\n    background-color: #271456;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
